import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Grid } from "@mui/material";
import SettingsLayout from "../../../../components/Layouts/SettingsLayout.jsx";
import SettingDropdown from "../Materials&Labor/SettingComponent.jsx";
import { useAdminDarkMode } from "../../../../contexts/AdminDarkModeContext.jsx";
import ThemeAppearancePanel from "../../../../components/Setting/ThemeAppearancePanel.jsx";

const COMPANY_ADMIN_HELP =
  "After you sign in: when Sync with system is on, the admin area follows your browser or OS light/dark setting. When Sync with system is off, Light or Dark applies only inside the app (not to the sign-in pages). Login, sign up, and forgot password always match your device theme. Saved to your account.";

function Theme() {
  const { CompanyUrl } = useParams();
  const { adminThemePreference, setAdminThemePreference } = useAdminDarkMode();
  const [isOpenDropDown, setIsOpenDropDown] = useState(false);
  const toggle = () => setIsOpenDropDown(!isOpenDropDown);

  // JOB-3349: use the shared SettingsLayout (same wrapper Accounts / Email
  // Settings / Logo Settings / etc. use) instead of a bespoke Bootstrap
  // Row/Col 2-column layout. The bespoke version was rendering the right
  // pane empty in some viewport / load orders.
  // The mt spacer offsets SettingsLayout's marginTop:-30px on desktop so
  // the card's top isn't clipped (matches Account.jsx).
  return (
    <SettingsLayout>
      <Grid sx={{ mt: { xs: 2, sm: 6 } }}>
        <ThemeAppearancePanel
          adminThemePreference={adminThemePreference}
          setAdminThemePreference={setAdminThemePreference}
          helpText={COMPANY_ADMIN_HELP}
        />
        <SettingDropdown
          isOpenDropDown={isOpenDropDown}
          toggle={toggle}
          CompanyUrl={CompanyUrl}
        />
      </Grid>
    </SettingsLayout>
  );
}

export default Theme;
